import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export function KpiCard({ title, value, icon: Icon, subtitle, className, onClick }) {
  return (
    <Card
      className={cn(
        'cursor-pointer hover:shadow-md transition-shadow duration-200 border bg-white',
        className
      )}
      onClick={onClick}
      data-testid={`kpi-card-${title?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium text-muted-foreground truncate">{title}</p>
            <p className="mt-1 text-2xl font-semibold tabular-nums" data-testid={`kpi-value-${title?.toLowerCase().replace(/\s+/g, '-')}`}>
              {value ?? 0}
            </p>
            {subtitle && (
              <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>
            )}
          </div>
          {Icon && (
            <div className="h-9 w-9 rounded-lg bg-muted flex items-center justify-center shrink-0">
              <Icon className="h-4 w-4 text-foreground" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
